import axios from 'axios'

export default class {
    async updateTestt(item) {
        return axios.put(`/test/update-name`, item)
    }

  async get(entity) {
    return axios
        .get(
            `/${entity}/all`
        ).then(res => res.data)
  }

  async getPresenceByDateAndByGrade(date, grade) {
    return axios
        .get(
            `/presence/date/grade/${date}/${grade}`
        ).then(res => res.data)
  }

  async getStudyByDateAndByGrade(date, grade) {
    return axios
        .get(
            `/study/date/grade/${date}/${grade}`
        ).then(res => res.data)
  }

     getTracingActive(grade) {
        return axios.get(`/tracing/active-grade/${grade}`)
    }


  postMany(items, entity) {
    return axios.post(`/${entity}/add-many`, items
    )
  }

  post(item, entity) {
    return axios.post(`/${entity}/add`, item
    )
  }

  update(item, entity) {
    return axios.put(`/${entity}/update`, item
    )
  }


  async delete(id, entity) {
    await axios.delete(`/${entity}/delete/${id}`
    )
  }

  async deleteMany(Ids, entity) {
    await axios.delete(`/${entity}/delete-many`,
                       {
                         data: Ids
                       }
    )
  }


  async getMe(entity) {
    return await axios
        .get(
            `/${entity}/me`
        ).then(({data}) => {
          return data
        })
  }

  async login(user, entity) {
    return await axios.post(`/${entity}/login`, user)
                      .then(res => {
                        localStorage.setItem("authorization",
                                             res.headers.authorization)
                        axios.defaults.headers.common['authorization'] =
                            res.headers.authorization
                      })
  }

  async getMySettings(entity) {
    return axios
        .get(
            `/${entity}/my_settings`
        ).then(res => res.data)
  }

  async getTotalPresencePupil(pupilId, startDate, endDate) {
    return axios
        .get(
            `/presence/pupil_total/${pupilId}/${startDate}/${endDate}`,
        ).then(res => res.data)
  }

  async getTotalTracingPupil(pupilId, startDate, endDate) {
    return axios
        .get(
            `/tracing/pupil_total/${pupilId}/${startDate}/${endDate}`,
        ).then(res => res.data)
  }

  async getTotalTestPupil(pupilId, startDate, endDate) {
    return axios
        .get(
            `/test/pupil_total/${pupilId}/${startDate}/${endDate}`,
        ).then(res => res.data)
  }

  async getTotalTestByGradeAndSubject(gradeId, subjectId, startDate, endDate) {
    return axios
        .get(
            `/test/grade_total_subject/${gradeId}/${subjectId}/${startDate}/${endDate}`,
        ).then(res => res.data)
  }

  async getTotalTrackByGradeAndSubject(gradeId, subjectId, startDate, endDate) {
    return axios
        .get(
            `/tracing/grade_total_subject/${gradeId}/${subjectId}/${startDate}/${endDate}`,
        ).then(res => res.data)
  }

  async getAllScheduleByGradeAndDay(dayId, gradeId) {
    return axios
        .get(
            `/schedule/allByGradeAndDay/${dayId}/${gradeId}`,
        ).then(res => res.data)
  }

  async getTotalPresenceByGradeAndSubject(gradeId, subjectId, startDate, endDate) {
        return axios
            .get(
                `/presence/grade_total_subject/${gradeId}/${subjectId}/${startDate}/${endDate}`,
            ).then(res => res.data)
    }


    async gerReportDates() {
        return axios
            .get(
                `/report/date-ranges`,
            ).then(res => res.data)
    }

     gerTestsNames() {
        return axios
            .get(
                `/test/all-names`,
            )
    }


    async getSystemMessages() {
        return axios
            .get(
                `/system-messages/all`,
            ).then(res => res.data)
    }

    async getRelevantSystemMessages() {
        return axios
            .get(
                `/system-messages/all-relevant`,
            ).then(res => res.data)
    }

    async addSystemMessage(systemMessage) {
        return axios
            .post(
                `/system-messages/add`, systemMessage
            ).then(res => res.data)
    }



    async addReportDates(dateRange) {
        return axios
            .post(
                `/report/date-ranges`, dateRange
            ).then(res => res.data)
    }

    async deleteReportDates(dateRanges) {
        return axios
            .delete(
                `/report/date-ranges`,
                {
                    data: dateRanges
                }
            ).then(res => res.data)
    }
}